import { render, staticRenderFns } from "./QccJudgmentdoccheck.vue?vue&type=template&id=246cc12c&scoped=true&"
import script from "./QccJudgmentdoccheck.vue?vue&type=script&lang=js&"
export * from "./QccJudgmentdoccheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246cc12c",
  null
  
)

component.options.__file = "QccJudgmentdoccheck.vue"
export default component.exports